import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {
  UpdateQuickServicesListing,
  AddMedia,
  getQuickServicesListing,
} from './../../../../Redux/Actions/UserAction';
import { timeOptions } from '../../../../Options';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';

const openStatus = ['OPEN', 'مفتوح'];

const QuickServicesWorkingHours = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const home = useSelector((state) => state.home);
  const getQuickServicesList = home?.getQuickServicesList;
  const getMybusiness = home?.getMybusiness;

  // After a save the action reloads the page, which wipes the store. The
  // business id arrives either from Redux (getMybusiness) or from
  // sessionStorage (set by the Header once /business/my resolves) — fetch the
  // owner's listing as soon as it's known so the form repopulates.
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

  useEffect(() => {
    if (validBid) {
      dispatch(getQuickServicesListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const [QuickServicesData, setQuickServicesData] = useState({
    calendar: {
      SUNDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      MONDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      TUESDAY: {
        status: 'CLOSE',
        openTime: '',
        endTime: '',
      },
      WEDNESDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      THURSDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      FRIDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
      SATURDAY: {
        status: 'OPEN',
        openTime: '',
        endTime: '',
      },
    },
  });

  useEffect(() => {
    if (getQuickServicesList?.length > 0) {
      let calendar;
      try {
        calendar =
          typeof getQuickServicesList?.[0]?.calendar === 'string'
            ? JSON.parse(getQuickServicesList?.[0]?.calendar)
            : getQuickServicesList?.[0]?.calendar;
      } catch (e) {
        calendar = undefined;
      }
      setQuickServicesData({
        calendar: {
          SUNDAY: {
            status: calendar?.SUNDAY?.status,
            openTime: calendar?.SUNDAY?.openTime,
            endTime: calendar?.SUNDAY?.endTime,
          },
          MONDAY: {
            status: calendar?.MONDAY?.status,
            openTime: calendar?.MONDAY?.openTime,
            endTime: calendar?.MONDAY?.endTime,
          },
          TUESDAY: {
            status: calendar?.TUESDAY?.status,
            openTime: calendar?.TUESDAY?.openTime,
            endTime: calendar?.TUESDAY?.endTime,
          },
          WEDNESDAY: {
            status: calendar?.WEDNESDAY?.status,
            openTime: calendar?.WEDNESDAY?.openTime,
            endTime: calendar?.WEDNESDAY?.endTime,
          },
          THURSDAY: {
            status: calendar?.THURSDAY?.status,
            openTime: calendar?.THURSDAY?.openTime,
            endTime: calendar?.THURSDAY?.endTime,
          },
          FRIDAY: {
            status: calendar?.FRIDAY?.status,
            openTime: calendar?.FRIDAY?.openTime,
            endTime: calendar?.FRIDAY?.endTime,
          },
          SATURDAY: {
            status: calendar?.SATURDAY?.status,
            openTime: calendar?.SATURDAY?.openTime,
            endTime: calendar?.SATURDAY?.endTime,
          },
        },
      });
    }
  }, [getQuickServicesList]);

  const handleChange = (e) => {
    if (e.target.id === 'SUNDAY') {
      setQuickServicesData({
        ...QuickServicesData,
        calendar: {
          ...QuickServicesData.calendar,
          SUNDAY: {
            ...QuickServicesData.calendar.SUNDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'MONDAY') {
      setQuickServicesData({
        ...QuickServicesData,
        calendar: {
          ...QuickServicesData.calendar,
          MONDAY: {
            ...QuickServicesData.calendar.MONDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'TUESDAY') {
      setQuickServicesData({
        ...QuickServicesData,
        calendar: {
          ...QuickServicesData.calendar,
          TUESDAY: {
            ...QuickServicesData.calendar.TUESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'WEDNESDAY') {
      setQuickServicesData({
        ...QuickServicesData,
        calendar: {
          ...QuickServicesData.calendar,
          WEDNESDAY: {
            ...QuickServicesData.calendar.WEDNESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'THURSDAY') {
      setQuickServicesData({
        ...QuickServicesData,
        calendar: {
          ...QuickServicesData.calendar,
          THURSDAY: {
            ...QuickServicesData.calendar.THURSDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'FRIDAY') {
      setQuickServicesData({
        ...QuickServicesData,
        calendar: {
          ...QuickServicesData.calendar,
          FRIDAY: {
            ...QuickServicesData.calendar.FRIDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'SATURDAY') {
      setQuickServicesData({
        ...QuickServicesData,
        calendar: {
          ...QuickServicesData.calendar,
          SATURDAY: {
            ...QuickServicesData.calendar.SATURDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    }
  };

  const datasubmit = () => {
    dispatch(UpdateQuickServicesListing(QuickServicesData));
  };
  const ResetHendler = () => {
    setQuickServicesData({});
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-quick-services-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-quick-services-parts',
      label: t('Manage Services'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-quick-services-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-quick-services-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  return (
    <div>
      <CommonBusinessHeader
        dataList={getQuickServicesList}
        getNameKey="quickServiceOwnerName"
      />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2 class="mb-4">{t('Manage Working Hours')}</h2>
              <form onSubmit={handleSubmit(datasubmit)}>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Day')}</div>
                    </div>
                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('From')}</label>
                    </div>
                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('To')}</label>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Sunday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SUNDAY"
                        value={QuickServicesData.calendar.SUNDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="SUNDAY"
                        name="endTime"
                        value={QuickServicesData.calendar.SUNDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                QuickServicesData.calendar.SUNDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SUNDAY"
                            onChange={(checked) => {
                              setQuickServicesData({
                                ...QuickServicesData,
                                calendar: {
                                  ...QuickServicesData.calendar,
                                  SUNDAY: {
                                    ...QuickServicesData.calendar.SUNDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={QuickServicesData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox1'
														value='option1'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Monday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="MONDAY"
                        value={QuickServicesData.calendar.MONDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="MONDAY"
                        name="endTime"
                        value={QuickServicesData.calendar.MONDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                QuickServicesData.calendar.MONDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="MONDAY"
                            onChange={(checked) => {
                              setQuickServicesData({
                                ...QuickServicesData,
                                calendar: {
                                  ...QuickServicesData.calendar,
                                  SUNDAY: {
                                    ...QuickServicesData.calendar.MONDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={QuickServicesData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox2'
														value='option2'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Tuesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="TUESDAY"
                        value={QuickServicesData.calendar.TUESDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="TUESDAY"
                        name="endTime"
                        value={QuickServicesData.calendar.TUESDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                QuickServicesData.calendar.TUESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="TUESDAY"
                            onChange={(checked) => {
                              setQuickServicesData({
                                ...QuickServicesData,
                                calendar: {
                                  ...QuickServicesData.calendar,
                                  SUNDAY: {
                                    ...QuickServicesData.calendar.TUESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={QuickServicesData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox3'
														value='option3'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Wednesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="WEDNESDAY"
                        value={QuickServicesData.calendar.WEDNESDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="WEDNESDAY"
                        name="endTime"
                        value={QuickServicesData.calendar.WEDNESDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                QuickServicesData.calendar.WEDNESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="WEDNESDAY"
                            onChange={(checked) => {
                              setQuickServicesData({
                                ...QuickServicesData,
                                calendar: {
                                  ...QuickServicesData.calendar,
                                  SUNDAY: {
                                    ...QuickServicesData.calendar.WEDNESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={QuickServicesData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox4'
														value='option4'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Thursday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="THURSDAY"
                        value={QuickServicesData.calendar.THURSDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="THURSDAY"
                        name="endTime"
                        value={QuickServicesData.calendar.THURSDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                QuickServicesData.calendar.THURSDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="THURSDAY"
                            onChange={(checked) => {
                              setQuickServicesData({
                                ...QuickServicesData,
                                calendar: {
                                  ...QuickServicesData.calendar,
                                  SUNDAY: {
                                    ...QuickServicesData.calendar.THURSDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={QuickServicesData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox5'
														value='option5'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Friday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="FRIDAY"
                        value={QuickServicesData.calendar.FRIDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="FRIDAY"
                        name="endTime"
                        value={QuickServicesData.calendar.FRIDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                QuickServicesData.calendar.FRIDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="FRIDAY"
                            onChange={(checked) => {
                              setQuickServicesData({
                                ...QuickServicesData,
                                calendar: {
                                  ...QuickServicesData.calendar,
                                  SUNDAY: {
                                    ...QuickServicesData.calendar.FRIDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={QuickServicesData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox6'
														value='option6'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Saturday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SATURDAY"
                        value={QuickServicesData.calendar.SATURDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="SATURDAY"
                        name="endTime"
                        value={QuickServicesData.calendar.SATURDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            QuickServicesData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                QuickServicesData.calendar.SATURDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SATURDAY"
                            onChange={(checked) => {
                              setQuickServicesData({
                                ...QuickServicesData,
                                calendar: {
                                  ...QuickServicesData.calendar,
                                  SUNDAY: {
                                    ...QuickServicesData.calendar.SATURDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}

                            // value={QuickServicesData.status}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox7'
														value='option7'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-5 ">
                  {/* <div class="col-6">
                    <button
                      type="reset"
                      // onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      href="#"
                      onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div> */}
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      class="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                    >
                      {t('Submit')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickServicesWorkingHours;
